<template>
  <div :loading="loading">
    <template v-if="!loading">
      <d-header
        :actions="[
          {
            label: $t('save'),
            primary: true,
            color: 'is-primary',
            action: submitForm,
          },
        ]"
        fluid
        :breadcrumbs="false"
        :class="{
          'pt-5': $laravel.user.is_owner_contact || $laravel.user.owner_id,
        }"
      >
        <h2 class="title is-4">
          <d-previous-btn
            :path="'/owners/' + model.owner_id + '/owner-businesses'"
          />
          {{ model.name }}
        </h2>
      </d-header>

      <v-form
        ref="form"
        action="edit"
        :model="model"
        :owner_id="model.owner_id"
      />
    </template>
  </div>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.title,
      __owner_business: this.title, // for breadcrumb
    };
  },
  components: {
    "v-form": form,
  },
  data() {
    return {
      model: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    },
  },
  watch: {
    "$route.params.ownerBusiness"() {
      this.fetch();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .get(
          this.$laravel.route("api.owner-businesses.show", {
            owner_business: this.$route.params.ownerBusiness,
            owner: this.$route.params.owner,
          })
        )
        .then((response) => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("/owner-businesses");
        });
    },
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
  },
};
</script>
